import React, { useEffect, useState } from "react";
import { FaWindows } from "react-icons/fa";
import { TfiDownload } from "react-icons/tfi";
import { FlexBoxHorizontal, FlexBoxVertical, Typography } from "../../atoms";
import MilkyWayMenu from "./MilkyWayMenu";

const MilkyWayDownloadCN = () => {
  const [updateUrl, setUpdateUrl] = useState({});

  useEffect(() => {
    fetch("/api/get-update-cn-url")
      .then((res) => res.json())
      .then((res) => {
        console.log("CN URLs:", res);
        setUpdateUrl(res);
      })
      .catch((err) => {
        console.error("Error fetching update url:", err);
      });
  }, []);

  return (
    <>
      <MilkyWayMenu currentCompany="cn" />

      <FlexBoxVertical
        style={{
          margin: "0 auto",
          width: "1150px",
          alignItems: "baseline",
          padding: "80px 20px",
          height: "auto",
        }}
      >
        <Typography
          variant="header1"
          style={{
            fontWeight: "bold",
            borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
            paddingBottom: "30px",
            width: "100%",
          }}
        >
          MilkyWay 下载
        </Typography>
        <h3
          style={{
            marginTop: "30px",
            marginBottom: "18px",
            fontSize: "19px",
            fontWeight: "bold",
          }}
        >
          一个具有更强大功能的新仪表盘，MilkyWay。
        </h3>
        <p style={{ fontSize: "14px" }}>
          请您选择适合您设备的按钮以下载 MilkyWay。
        </p>
        <FlexBoxHorizontal
          style={{
            height: "40%",
            borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
            paddingBottom: "2%",
          }}
        >
          <DownloadCard
            platform="Windows"
            icon={<FaWindows style={{ marginBottom: "-1%" }} />}
            links={[
              {
                label: "Windows版 MilkyWay",
                url: updateUrl.windows,
              },
            ]}
          />
        </FlexBoxHorizontal>
        <p style={{ margin: "20px auto 10px auto" }}>
          如有任何问题，请联系Sapphire。
        </p>
      </FlexBoxVertical>
    </>
  );
};

function DownloadCard({ platform, icon, links }) {
  return (
    <div
      style={{
        width: "280px",
        height: "260px",
        backgroundColor: "#353339",
        margin: "50px",
        borderRadius: "5px",
        padding: "20px",
        color: "white",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ fontSize: "30px", margin: "10px" }}>
        {icon}&nbsp;{platform}
      </div>
      {links.map((link, index) => (
        <a
          key={index}
          href={link.url}
          download
          style={{
            display: "inline-block",
            backgroundColor: link.url ? "white" : "#888",
            border: "0px solid #202a44",
            width: "80%",
            height: "50px",
            fontSize: "15px",
            borderRadius: "30px",
            textAlign: "center",
            lineHeight: "50px",
            color: "#353339",
            textDecoration: "none",
            margin: "15px 20px",
            pointerEvents: link.url ? "auto" : "none",
            opacity: link.url ? 1 : 0.6,
          }}
          onMouseOver={(e) =>
            link.url && (e.target.style.boxShadow = "0 0 5px white")
          }
          onMouseOut={(e) => (e.target.style.boxShadow = "none")}
        >
          <TfiDownload style={{ marginRight: "8px", fontSize: "12px" }} />
          {link.url ? link.label : "加载中..."}
        </a>
      ))}
    </div>
  );
}

export default MilkyWayDownloadCN;
